import { useState, useEffect, useRef } from "react";
import "../assets/css/Contact.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { Helmet } from "react-helmet";
import data from "../../src/component/ApiUrl/meta_api";
import axios from "axios";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";

const contact = [
  {
    icon: <FaPhoneAlt />,
    label: "Phone",
    val: "(+91) 8428010909",
    sub: "(+91) 8428330909",
    btn: "Call Now",
    link: "tel:+918428010909",
  },
  {
    icon: <FaEnvelope />,
    label: "Email",
    val: "info@skimitarhindusthan.com",
    sub: "",
    btn: "Send Email",
    link: "mailto:info@skimitarhindusthan.com",
  },
  {
    icon: <FaMapMarkerAlt />,
    label: "Address",
    val: "1st Floor, D.No:027,Ward 25th, 2nd Cross, Annamalai Layout, Nalli Hospital Road, Erode -638011",
    sub: "",
    btn: "View Map",
    link: "https://www.google.com/maps/place/11%C2%B020'45.9%22N+77%C2%B042'58.7%22E/@11.346076,77.7137226,750m/data=!3m2!1e3!4b1!4m4!3m3!8m2!3d11.346076!4d77.7162975?hl=en&entry=ttu&g_ep=EgoyMDI2MDQwMS4wIKXMDSoASAFQAw%3D%3D",
  },
];

const faqs = [
  {
    q: "How quickly will I receive a response after submitting the form?",
    a: "Our team typically responds within 24 business hours. For urgent matters, call us at (+91) 8428010909 or (+91) 8428330909 during business hours.",
  },
  {
    q: "Do you offer online training programs?",
    a: "Yes! All our training programs are available in both online and classroom formats. You can attend live online sessions from anywhere in India or join our in-person batches at our Erode training centre.",
  },
  {
    q: "Can you deliver services and training outside Erode?",
    a: "Absolutely. We provide pan-India service delivery and on-site corporate training across all major states including Tamil Nadu, Karnataka, Andhra Pradesh, Maharashtra, Kerala and more.",
  },
  {
    q: "Do you provide placement assistance after course completion?",
    a: "Yes, we offer dedicated placement support including resume building, mock interview sessions, career counselling, and direct job referrals to our industry partner network.",
  },
  {
    q: "How can I enroll in a corporate training program for my team?",
    a: "Fill out the contact or quote form above and select 'Corporate Training'. Our training team will reach out to understand your team's needs and design a customized program for you.",
  },
  {
    q: "What is the office address of Skimitar Hindusthan?",
    a: "We are located at: 1st Floor, D.No: 027, Ward 25th, 2nd Floor, Annamalai Layout, Nalli Hospital Road, Erode – 638011, Tamil Nadu, India.",
  },
];

// Course Categories Data
const courseCategories = {
  "Industrial Automation ": [
    "Master PLC Programming & Industrial Automation",
    "Certified PLC & SCADA Engineer",
    "Industrial Automation Engineer",
    "Industrial Automation Mastery",
  ],
  "Embedded Systems & IIoT ": [
    "Embedded Systems Kickstart",
    "Embedded Systems Engineer",
    "Embedded & IIoT Mastery",
  ],
  "Digital Marketing": [
    "Digital Marketing Power-Up",
    "Advanced Digital Marketing Strategies",
    "Digital Marketing Mastery",
  ],
  "IT & Software Development": [
    "Python Full Stack Development",
    "Java Full Stack Development",
    "MERN Stack Development",
    "Mobile App Development",
    "Data Analytics",
    "Data Science & Machine Learning",
    "UI/UX Design",
    "AWS Cloud",
    "DevOps Engineer",
    "Cybersecurity & Ethical Hacking",
  ],
};

// Service Categories Data
const serviceCategories = {
  "Industrial Automation Services": [
    "Automation System Design & Engineering",
    "SCADA & Process Control Systems",
    "Robotic Solutions & PLC Programming",
    "Panel Fabrication & Control Systems",
    "Energy Management System (EMS)",
    "Training & Technical Support Services",
  ],
  "Our Embedded Systems & IIoT Services": [
    "Embedded Systems Design & Development",
    "IIoT Connectivity & Integration",
    "Smart Monitoring & Predictive Analytics",
    "Industrial Automation & Control Systems",
    "Wireless Sensor & Network Solutions",
    "Digital Twin & Energy Optimization",
  ],
  "Digital Marketing Services": [
    "SEO & Content Marketing",
    "Social Media Marketing",
    "Paid Ads & PPC Campaigns",
    "Branding, Design & Video Production",
    "Website Design & Development",
    "Analytics, Email & Performance Reporting",
  ],
  "IT & Software Services": [
    "Web & Mobile App Development",
    "AI, Data Science & Machine Learning",
    "Cloud Computing & DevOps",
    "Cybersecurity Solutions",
    "Custom Software & ERP Solutions",
    "Software Testing, QA & IT Support",
  ],
};

// Title Component
function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

export default function Contact() {
  const [meta, setMeta] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [defaultBranchId, setDefaultBranchId] = useState(null);
  
  // Form state for dynamic dropdowns
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedSpecificCourse, setSelectedSpecificCourse] = useState("");
  const [selectedServiceCategory, setSelectedServiceCategory] = useState("");
  const [selectedSpecificService, setSelectedSpecificService] = useState("");
  
  // Form field states
  const [formData, setFormData] = useState({
    user_name: "",
    user_mobile: "",
    user_email: "",
    category: "",
    message: "",
  });

  // Error states for validation
  const [errors, setErrors] = useState({
    user_mobile: ""
  });

  const formRef = useRef();
  
  // Get API URL from environment variable
  const API_URL = process.env.REACT_APP_API_URL || "https://bs.aalantechsoft.com:8003/api";

  // Fetch Erode branch ID on component mount
  useEffect(() => {
    const fetchErodeBranch = async () => {
      try {
        const response = await axios.get(`${API_URL}/Branch`);
        const erodeBranch = response.data.find(branch => 
          branch.branch_name && branch.branch_name.toLowerCase().includes("erode")
        );
        if (erodeBranch) {
          setDefaultBranchId(erodeBranch._id);
          console.log("Default branch set to Erode:", erodeBranch.branch_name);
        } else if (response.data.length > 0) {
          setDefaultBranchId(response.data[0]._id);
        }
      } catch (error) {
        console.error("Error fetching branch:", error);
      }
    };
    
    fetchErodeBranch();
  }, [API_URL]);

  // scroll top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const fetchData = () => {
    const ContactMeta = data[0]?.contact_page;
    if (ContactMeta) {
      setMeta(ContactMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 700, once: true });
  }, []);

  // Auto-hide success modal after 2 seconds
  useEffect(() => {
    if (showSuccessModal) {
      const timer = setTimeout(() => {
        setShowSuccessModal(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessModal]);

  // Handle input changes with validation
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Phone number validation - only allow 10 digits
    if (name === "user_mobile") {
      // Remove any non-digit characters
      const cleaned = value.replace(/\D/g, "");
      // Limit to 10 digits
      const limited = cleaned.slice(0, 10);
      
      setFormData((prev) => ({ ...prev, [name]: limited }));
      
      // Validate phone number
      if (limited.length > 0 && limited.length !== 10) {
        setErrors((prev) => ({ ...prev, user_mobile: "Phone number must be exactly 10 digits" }));
      } else {
        setErrors((prev) => ({ ...prev, user_mobile: "" }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle category change (Service / Course)
  // const handleCategoryChange = (e) => {
  //   setSelectedCategory(e.target.value);
  //   setSelectedCourseCategory("");
  //   setSelectedSpecificCourse("");
  //   setSelectedServiceCategory("");
  //   setSelectedSpecificService("");
  // };

  const handleCategoryChange = (e) => {
  const value = e.target.value;

  setSelectedCategory(value);

  setFormData((prev) => ({
    ...prev,
    category: value,
  }));

  // reset மற்ற fields
  setSelectedCourseCategory("");
  setSelectedSpecificCourse("");
  setSelectedServiceCategory("");
  setSelectedSpecificService("");
};

  // Handle course category change
  const handleCourseCategoryChange = (e) => {
    setSelectedCourseCategory(e.target.value);
    setSelectedSpecificCourse("");
  };

  // Handle service category change
  const handleServiceCategoryChange = (e) => {
    setSelectedServiceCategory(e.target.value);
    setSelectedSpecificService("");
  };

  // Validate form before submission
  const validateForm = () => {
    let isValid = true;
    const newErrors = { user_mobile: "" };
    
    // Validate phone number
    if (formData.user_mobile.length !== 10) {
      newErrors.user_mobile = "Phone number must be exactly 10 digits";
      isValid = false;
    }
    
    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!validateForm()) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }
    
    setLoading(true);

    // Prepare the final need value
    let finalNeed = "";
    let enquiryType = "General";
    let courseCategory = "";
    let serviceCategory = "";
    
    if (selectedCategory === "Service") {
      finalNeed = `Service: ${selectedSpecificService || "Not specified"}`;
      enquiryType = "Service Enquiry";
      serviceCategory = selectedServiceCategory || "";
    } else if (selectedCategory === "Course") {
      finalNeed = `Course: ${selectedSpecificCourse || "Not specified"}`;
      enquiryType = "Course Enquiry";
      courseCategory = selectedCourseCategory || "";
    } else {
      finalNeed = "General Enquiry";
      enquiryType = "General Enquiry";
    }

    // Prepare lead data for backend (ALWAYS send for all enquiries)
    const leadData = {
      student_name: formData.user_name,
      mobile_no: formData.user_mobile,
      email: formData.user_email,
      category: formData.category,
      Prefered_course: selectedSpecificCourse || "Not specified",
      Source_type: "Website",
      Enquiry_date: new Date().toISOString().split('T')[0],
      Enquiry_time: new Date().toLocaleTimeString(),
      followups_status: "New",
      message: formData.message,
      enquiry_type: enquiryType,
      service_need: finalNeed,
      // course_category: courseCategory,
      service_category: serviceCategory,
      source_page: "Contact Page",
      branch_id: defaultBranchId,
      user_agent: navigator.userAgent
    };

    console.log("=== Sending Enquiry to ERP ===");
    console.log("Lead Data:", leadData);

    try {
      const response = await axios.post(`${API_URL}/leads`, leadData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        timeout: 15000
      });
      
      console.log("✅ Enquiry saved to database!");
      console.log("Backend Response:", response.data);
      
    } catch (apiError) {
      console.error("❌ Failed to save enquiry:", apiError);
      // Continue with email even if database save fails
    }

    // Send email via EmailJS (for ALL enquiries)
    try {
      console.log("=== Sending Email via EmailJS ===");
      
      if (formRef.current) {
        const inputs = formRef.current.querySelectorAll("input, textarea, select");
        inputs.forEach((input) => {
          if (input.name === "user_name") input.value = formData.user_name;
          if (input.name === "user_mobile") input.value = formData.user_mobile;
          if (input.name === "user_email") input.value = formData.user_email;
          if (input.name === "user_need") input.value = finalNeed;
          if (input.name === "message") input.value = formData.message;
        });
      }

      const emailResult = await emailjs.sendForm(
        "service_1l6tarq",
        "template_pgbv6sl",
        formRef.current,
        "YVQ5H8UeZgOlMDTgO"
      );
      
      console.log("✅ Email sent successfully:", emailResult);
      toast.success("Message sent successfully! Our team will contact you soon.");
      setShowSuccessModal(true);
      
      // Reset form on success
      setFormData({
        user_name: "",
        user_mobile: "",
        user_email: "",
        message: "",
      });
      setSelectedCategory("");
      setSelectedCourseCategory("");
      setSelectedSpecificCourse("");
      setSelectedServiceCategory("");
      setSelectedSpecificService("");
      setErrors({ user_mobile: "" });
      
    } catch (emailError) {
      console.error("❌ Email Error:", emailError);
      toast.error("Message sent but there was an issue. Our team will contact you soon.");
      setShowSuccessModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Contact Us"}</title>
      </Helmet>

      {/* Loading Overlay */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../assets/img/SH Logo.png")}
              alt="Loading"
            />
          </div>
        </div>
      )}

      {/* Hero */}
      <div
        className="text-center mb-4 d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.86), rgba(0, 0, 0, 0.86)), url(" +
            require("../assets/img/Contact/banner.jpg") +
            ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "60vh",
        }}
      >
        <span
          className="badge mb-3 px-3 py-2"
          style={{
            background: "#cc0000",
            fontSize: "1rem",
            letterSpacing: "0.5px",
          }}
          data-aos="fade-down"
          data-aos-duration="600"
        >
          Contact Us
        </span>

        <h1
          className="text-white fw-medium mb-3"
          style={{ fontSize: "clamp(20px,4vw,28px)" }}
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-duration="700"
        >
          Let's Start a <span className="text-red">Conversation</span>
        </h1>

        <p
          className="mx-auto mb-0 content-text text-light"
          style={{
            maxWidth: "520px",
          }}
          data-aos="fade-up"
          data-aos-delay="250"
          data-aos-duration="700"
        >
          Whether you're looking for a technology solution, training program, or
          more, we're here to help. Reach us anytime.
        </p>
      </div>

      {/* Info Strip */}
      <div className="container container_width mt-5">
        <div className="row g-4 justify-content-center align-items-stretch">
          {contact.map((data, i) => (
            <div
              key={i}
              className={`col-12 col-sm-6 col-lg-4 d-flex ${i >= 2 ? "mt-md-2" : ""}`}
              data-aos="fade-up"
              data-aos-delay={i * 350}
              data-aos-duration="700"
            >
              <div className="h-100 w-100 text-center d-flex flex-column">
                {/* Icon */}
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                  style={{
                    width: "70px",
                    height: "70px",
                    background: "linear-gradient(135deg,#cc0000,#e63939)",
                    fontSize: "28px",
                    color: "#fff",
                  }}
                >
                  {data.icon}
                </div>

                {/* Title */}
                <h5
                  className="fw-bold text-dark mb-2"
                  style={{ fontSize: "20px" }}
                >
                  {data.label}
                </h5>

                {/* Content */}
                <div className="flex-grow-1">
                  <p className="content_text text-center mb-1">{data.val}</p>

                  {data.sub && (
                    <p className="mb-0 text-center content_text">{data.sub}</p>
                  )}
                </div>

                {/* Button */}
                <div className="mt-3">
                  <a
                    href={data.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-danger rounded-pill w-50"
                    style={{
                      borderWidth: "1.5px",
                      fontSize: "14px",
                      padding: "8px 0",
                    }}
                  >
                    {data.btn}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Form + Right */}
      <div className="margin_top bg_color py-5">
        <div className="container container_width">
          <div data-aos="fade-right" data-aos-duration="600">
            <SectionLabel text="Get In Touch" />
          </div>

          <h2
            className="fw-semibold mb-3"
            style={{ fontSize: 20 }}
            data-aos="fade-right"
            data-aos-delay="100"
            data-aos-duration="600"
          >
            We'd Love to Hear From You
          </h2>

          <p
            className="mb-4 content_text"
            data-aos="fade-right"
            data-aos-delay="150"
            data-aos-duration="600"
          >
            Fill in the form below or reach us directly our team will get back
            to you within 24 hours.
          </p>

          <div className="container container_width mt-5">
            <div className="row g-4">
              {/* LEFT SIDE */}
              <div className="col-12 col-lg-6 d-flex flex-column gap-4">
                {/* MAP */}
                <div
                  className="card border overflow-hidden p-2"
                  data-aos="zoom-in"
                  data-aos-duration="800"
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3911.835131802722!2d77.71723792216663!3d11.346750094677956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96f540ee8927d%3A0xbe40040a8a9d363d!2sSKIMITAR%20HINDHUSTHAN%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1776060872179!5m2!1sen!2sin"
                    width="600"
                    height="450"
                    style={{ border: "0" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Skimitar Hindusthan Location Map"
                  ></iframe>
                </div>

                {/* BUSINESS HOURS */}
                <div
                  className="card border p-3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="700"
                >
                  <p className="fw-medium mb-3" style={{ fontSize: "12px" }}>
                    🕐 Business Hours
                  </p>

                  {[
                    {
                      day: "Monday – Saturday",
                      time: "9:00 AM – 7:00 PM",
                      closed: false,
                    },
                    { day: "Sunday", time: "9:00 AM – 6:00 PM", closed: true },
                  ].map(({ day, time, closed }) => (
                    <div
                      key={day}
                      className="d-flex justify-content-between align-items-center border-bottom py-2"
                      style={{ fontSize: "12px" }}
                    >
                      <span className="text-secondary">{day}</span>

                      <span
                        className="fw-medium"
                        style={closed ? { color: "#E24B4A" } : {}}
                      >
                        {time}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT SIDE FORM */}
              <div
                className="col-12 col-lg-6"
                data-aos="zoom-in"
                data-aos-delay="100"
                data-aos-duration="800"
              >
                <div className="card shadow p-4 h-100">
                  <p
                    className="fw-medium border-bottom pb-3 mb-3"
                    style={{ fontSize: "14px" }}
                  >
                    ✉️ Send Us a Message
                  </p>

                  <form ref={formRef} onSubmit={handleSubmit} noValidate>
                    <div className="row g-3 mb-3">
                      <div className="col-12 col-sm-6">
                        <label
                          className="form-label fw-medium"
                          style={{ fontSize: "11px" }}
                        >
                          Full Name *
                        </label>

                        <input
                          type="text"
                          name="user_name"
                          className="form-control"
                          placeholder="Your full name"
                          style={{ fontSize: "12px" }}
                          value={formData.user_name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="col-12 col-sm-6">
                        <label
                          className="form-label fw-medium"
                          style={{ fontSize: "11px" }}
                        >
                          Phone Number *
                        </label>

                        <input
                          type="tel"
                          name="user_mobile"
                          className={`form-control ${errors.user_mobile ? 'is-invalid' : ''}`}
                          placeholder="10 digit mobile number"
                          style={{ fontSize: "12px" }}
                          value={formData.user_mobile}
                          onChange={handleInputChange}
                          maxLength={10}
                          pattern="[0-9]{10}"
                          required
                        />
                        {errors.user_mobile && (
                          <div className="invalid-feedback" style={{ fontSize: "11px", display: "block" }}>
                            {errors.user_mobile}
                          </div>
                        )}
                        <small className="text-muted" style={{ fontSize: "10px" }}>
                          Enter 10 digit mobile number
                        </small>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label fw-medium"
                        style={{ fontSize: "11px" }}
                      >
                        Email Address *
                      </label>

                      <input
                        type="email"
                        name="user_email"
                        className="form-control"
                        placeholder="your@email.com"
                        style={{ fontSize: "12px" }}
                        value={formData.user_email}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {/* Select your category dropdown */}
                    <div className="mb-3">
                      <label
                        className="form-label fw-medium"
                        style={{ fontSize: "11px" }}
                      >
                        Select Category *
                      </label>

                      <select
                        className="form-select"
                        name="category"
                        style={{ fontSize: "12px" }}
                        value={formData.category}
                        // onChange={handleCategoryChange}
                        onChange={handleCategoryChange}
                        required
                      >
                        <option value="">Select your category</option>
                        <option value="Service">Service</option>
                        <option value="Course">Course</option>
                      </select>
                    </div>

                    {/* Conditional rendering for COURSE selection */}
                    {selectedCategory === "Course" && (
                      <>
                        <div className="mb-3">
                          <label
                            className="form-label fw-medium"
                            style={{ fontSize: "11px" }}
                          >
                            Select Course Category *
                          </label>

                          <select
                            className="form-select"
                            style={{ fontSize: "12px" }}
                            value={selectedCourseCategory}
                            onChange={handleCourseCategoryChange}
                            required
                          >
                            <option value="">Select Course Category</option>
                            {Object.keys(courseCategories).map((category) => (
                              <option key={category} value={category}>
                                {category}
                              </option>
                            ))}
                          </select>
                        </div>

                        {selectedCourseCategory && (
                          <div className="mb-3">
                            <label
                              className="form-label fw-medium"
                              style={{ fontSize: "11px" }}
                            >
                              Select Specific Course *
                            </label>

                            <select
                              className="form-select"
                              style={{ fontSize: "12px" }}
                              value={selectedSpecificCourse}
                              onChange={(e) => setSelectedSpecificCourse(e.target.value)}
                              required
                            >
                              <option value="">Select Specific Course</option>
                              {courseCategories[selectedCourseCategory]?.map((course) => (
                                <option key={course} value={course}>
                                  {course}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </>
                    )}

                    {/* Conditional rendering for SERVICE selection */}
                    {selectedCategory === "Service" && (
                      <>
                        <div className="mb-3">
                          <label
                            className="form-label fw-medium"
                            style={{ fontSize: "11px" }}
                          >
                            Select Service Category *
                          </label>

                          <select
                            className="form-select"
                            style={{ fontSize: "12px" }}
                            value={selectedServiceCategory}
                            onChange={handleServiceCategoryChange}
                            required
                          >
                            <option value="">Select Service Category</option>
                            {Object.keys(serviceCategories).map((category) => (
                              <option key={category} value={category}>
                                {category}
                              </option>
                            ))}
                          </select>
                        </div>

                        {selectedServiceCategory && (
                          <div className="mb-3">
                            <label
                              className="form-label fw-medium"
                              style={{ fontSize: "11px" }}
                            >
                              Select Specific Service *
                            </label>

                            <select
                              className="form-select"
                              style={{ fontSize: "12px" }}
                              value={selectedSpecificService}
                              onChange={(e) => setSelectedSpecificService(e.target.value)}
                              required
                            >
                              <option value="">Select Specific Service</option>
                              {serviceCategories[selectedServiceCategory]?.map((service) => (
                                <option key={service} value={service}>
                                  {service}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </>
                    )}

                    {/* Hidden input for emailjs */}
                    <input
                      type="hidden"
                      name="user_need"
                      value={
                        selectedCategory === "Service"
                          ? `Service Category: ${selectedServiceCategory || ""}, Specific Service: ${selectedSpecificService || ""}`
                          : selectedCategory === "Course"
                          ? `Course Category: ${selectedCourseCategory || ""}, Specific Course: ${selectedSpecificCourse || ""}`
                          : "General Enquiry"
                      }
                    />

                    <div className="mb-3">
                      <label
                        className="form-label fw-medium"
                        style={{ fontSize: "11px" }}
                      >
                        Your Message *
                      </label>

                      <textarea
                        className="form-control"
                        name="message"
                        rows={5}
                        placeholder="Tell us more about your requirement..."
                        style={{ fontSize: "12px" }}
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn w-100 text-white mt-2 fw-medium"
                      style={{ background: "#cc0000", fontSize: "13px" }}
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message →"}
                    </button>

                    <p
                      className="text-center text-muted mt-2 mb-0"
                      style={{ fontSize: "10px" }}
                    >
                      We respect your privacy. Your information will never be
                      shared.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="container container_width margin_top">
        <div className="row align-items-center justify-content-center g-4 mb-5">
          {/* LEFT SIDE FAQ */}
          <div className="col-12 col-lg-7">
            <div data-aos="fade-right" data-aos-duration="600">
              <SectionLabel text="Faq" />
            </div>

            <h2
              className="fw-semibold mb-4"
              style={{ fontSize: "20px" }}
              data-aos="fade-right"
              data-aos-delay="100"
              data-aos-duration="600"
            >
              Frequently Asked Questions
            </h2>

            <div className="accordion" id="faqAccordion">
              {faqs.map((faq, i) => (
                <div
                  className="accordion-item"
                  key={i}
                  data-aos="fade-right"
                  data-aos-delay={i * 350}
                  data-aos-duration="600"
                >
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${i !== 0 ? "collapsed" : ""} content_text`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#faq${i}`}
                      aria-expanded={i === 0 ? "true" : "false"}
                      aria-controls={`faq${i}`}
                      style={{
                        fontWeight: "600",
                        color: i === 0 ? "#fff" : "#000",
                        backgroundColor: i === 0 ? "#cc0000" : "#fff",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#cc0000";
                        e.target.style.color = "#fff";
                      }}
                      onMouseLeave={(e) => {
                        if (e.target.classList.contains("collapsed")) {
                          e.target.style.backgroundColor = "#fff";
                          e.target.style.color = "#000";
                        }
                      }}
                    >
                      {faq.q}
                    </button>
                  </h2>

                  <div
                    id={`faq${i}`}
                    className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body"
                      style={{ fontSize: "13px", lineHeight: "1.7" }}
                    >
                      {faq.a}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE IMAGE */}
          <div
            className="col-12 col-lg-5 text-center"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="800"
          >
            <img
              src={require("../assets/img/Contact/contact-1.jpg")}
              alt="FAQ"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-success">Success!</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowSuccessModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <h5 className="text-red">Message Sent Successfully</h5>
                <p>Thank you for contacting us. We will get back to you soon.</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-danger"
                  onClick={() => setShowSuccessModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}